import React, { useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';
import Skeleton from '../../../../components/Skeleton';
import TableTemplate from '../../../../components/table/index';
import { getAllHistory } from '../../../../controllers/HistoryController';

const TableComponent = ({ t }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const columns = useMemo(() => [
        { field: 'category', title: t('common.category.title'), sortable: true },
        { field: 'action', title: t('common.action.title'), sortable: true },
        { field: 'created_at', title: t('common.created.title'), sortable: true },
        { field: 'created_by', title: t('common.created.by'), sortable: true },
    ], [t]);
    
    const filters = useMemo(() => [
        { field: 'action', label: t('common.action.title'), by: t('common.action.add'), labelBy: t('common.action.add'), mode: 'exact' },
        { field: 'action', label: t('common.action.title'), by: t('common.action.edit'), labelBy: t('common.action.edit'), mode: 'exact' },
        { field: 'action', label: t('common.action.title'), by: t('common.action.delete'), labelBy: t('common.action.delete'), mode: 'exact' },
        { field: 'category', label: t('common.category.title'), by: t('common.category.role'), labelBy: t('common.category.role'), mode: 'exact' },
        { field: 'category', label: t('common.category.title'), by: t('common.category.user'), labelBy: t('common.category.user'), mode: 'exact' },
        { field: 'category', label: t('common.category.title'), by: t('common.category.therapyMaterial'), labelBy: t('common.category.therapyMaterial'), mode: 'exact' },
    ], [t]);
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                const result = await getAllHistory();
                const formattedRows = result.history.map((history) => {
                    const formattedCategory = history.category.toLowerCase().replace(/\s(.)/g, (match) => match.toUpperCase()).replace(/\s/g, '');
                    const translatedCategory = t(`common.category.${formattedCategory}`, { defaultValue: history.category });
                    
                    return {
                        id: history.id,
                        category: translatedCategory,
                        action: t(`common.action.${history.action.toLowerCase()}`),
                        created_at: history.created_at,
                        created_by: history.created_by
                    }
                });
                
                setRows(formattedRows);
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            };
        };
        
        fetchData();
    }, [t]);
    
    if (loading) {
        return (
        <Skeleton className='h-96 w-full rounded-lg' />
        );
    };
    
    return (
        <div>
            <TableTemplate
                rows={rows}
                columns={columns}
                filters={filters}
                fileName={t('menu.history')}
            />
        </div>
    );
};

export default TableComponent;
